import { translate } from '@components/i18n';
import { CampaignResponse } from '@models/campaign';
import { selectCampaign } from '@redux/slices/campaign';
import { getCampaignStrategy } from '@domain/campaign/strategies';
import { Dispatch } from '@reduxjs/toolkit';
import { Button, FormInstance, notification, Row } from 'antd';

export const getCurrentChanged = (
    campaigns: CampaignResponse[],
    changedValue: any,
): CampaignResponse => {
    let campaign = undefined;
    Object.entries(changedValue).map((v) => {
        const [label, value] = v;

        if (!value) return;

        const id = Number(label.replace('camp', ''));
        campaign = campaigns.find((c) => c.id === id);
    });
    return campaign;
};

interface CampaignExclusive {
    exclusiveId: number;
    isExclusive: boolean;
}

export const getCurrentExclusive = (
    campaigns: CampaignResponse[],
    allValues: any,
): CampaignExclusive => {
    let isExclusive = false;
    let exclusiveId = 0;

    Object.entries(allValues).map((v) => {
        const [label, value] = v;

        if (!value) return;

        const id = Number(label.replace('camp', ''));
        const campaign = campaigns.find((c) => c.id === id);

        if (campaign && campaign.exclusivo) {
            isExclusive = campaign.exclusivo;
            exclusiveId = campaign.id;
        }
    });

    return { isExclusive, exclusiveId };
};

export const showExclusiveModal = (
    form: FormInstance,
    selectedCampaigns: CampaignResponse[],
    exclusiveCampaign: CampaignExclusive,
    dispatch: Dispatch<any>,
): void => {
    // const dispatch = useDispatch();
    const key = `open${Date.now()}`;
    const btn = (
        <Row>
            <Button
                type="primary"
                size="small"
                onClick={() => {
                    const obj = {
                        [`camp${exclusiveCampaign.exclusiveId}`]: false,
                    };

                    form.setFieldsValue({ ...obj });
                    notification.close(key);
                }}
            >
                Não
            </Button>
            <Button
                type="primary"
                size="small"
                style={{ marginLeft: 5 }}
                danger
                onClick={() => {
                    form.setFieldsValue(
                        Object.assign(
                            {},
                            ...selectedCampaigns.map((c) => {
                                const o = {};
                                if (
                                    `${exclusiveCampaign.exclusiveId}` ===
                                    `${c.id}`
                                ) {
                                    o[`camp${c.id}`] = true;
                                } else o[`camp${c.id}`] = false;
                                return o;
                            }),
                        ),
                    );
                    dispatch(selectCampaign([exclusiveCampaign.exclusiveId]));
                    notification.close(key);
                }}
            >
                Sim
            </Button>
        </Row>
    );

    notification.open({
        message: translate("columns.exclusiveCampain"),
        description: translate("general.youChoosedAExclusiveCampain"),
        btn,
        key,
        // onClose: close,
    });
};

export const showConflictExclusive = (
    form: FormInstance,
    selectedCampaigns: CampaignResponse[],
    exclusiveCampaign: CampaignExclusive,
    currentCampaign: CampaignResponse,
    dispatch: Dispatch<any>,
): void => {
    const key = `open${Date.now()}`;
    const btn = (
        <Row>
            <Button
                type="primary"
                size="small"
                onClick={() => {
                    const obj = {
                        [`camp${currentCampaign.id}`]: false,
                    };

                    form.setFieldsValue({ ...obj });
                    notification.close(key);
                }}
            >
                Não
            </Button>
            <Button
                type="primary"
                size="small"
                style={{ marginLeft: 5 }}
                danger
                onClick={() => {
                    form.setFieldsValue(
                        Object.assign(
                            {},
                            ...selectedCampaigns.map((c) => {
                                const o = {};
                                if (
                                    `${exclusiveCampaign.exclusiveId}` ===
                                    `${c.id}`
                                ) {
                                    o[`camp${c.id}`] = false;
                                } else o[`camp${c.id}`] = false;
                                return o;
                            }),
                        ),
                    );
                    dispatch(selectCampaign([currentCampaign.id]));
                    notification.close(key);
                }}
            >
                Sim
            </Button>
        </Row>
    );

    notification.open({
        message: translate("general.choosedExclusiveCampain"),
        description: translate("general.youChoosedAExclusiveCampainThatWasChoosedBefore"),
        btn,
        key,
        closeIcon: <div></div>,
        // onClose: close,
    });
};

export const verifyConflictItems = (
    form: FormInstance,
    selectedCampaigns: CampaignResponse[],
    currentCampaign: CampaignResponse,
    dispatch: Dispatch<any>,
    values: number[],
): void => {
    if (selectedCampaigns.length === 0) {
        dispatch(selectCampaign(values));
        return;
    }
    if (!currentCampaign) {
        dispatch(selectCampaign(values));
        return;
    }

    const strategy = getCampaignStrategy(currentCampaign.tipo);
    const conflicts = strategy
        ? strategy.detectConflicts(currentCampaign, selectedCampaigns)
        : [];

    if (conflicts.length === 0) {
        dispatch(selectCampaign(values));
        return;
    }

    const conflict = conflicts[0];
    const otherId = conflict.campaignIds.find((id) => id !== currentCampaign.id);
    const other = selectedCampaigns.find((c) => c.id === otherId);

    const key = `open${Date.now()}`;
    form.setFieldsValue({ [`camp${currentCampaign.id}`]: false });
    notification.close(key);
    notification.open({
        message: translate('general.conflictCampain'),
        description: translate('general.youChoosedAConflictCampain')
            .replaceAll('#NAME', other?.nome ?? '')
            .replaceAll('#ITEM', conflict.numeroItem)
            .replaceAll('#WHERE', 'itens'),
        key,
    });
};
